import React, {useEffect, useState} from 'react';
import { Table } from "antd";
import {compareColumnData} from'./columns';
import {getGridTableHeight, amountFormatter, floatFormatter} from '../Common/util';
import {Chart04} from './Chart';

/** -------------------------------------------------------------------------- **/
function Summary({compareList, assetList_u}) {

  const [compareSumData, setCompareSumData] = useState({total_score : 0, eval_score : 0, level : 0, total_score_U : 0, eval_score_U : 0, level_U : 0, improve_rate : 0});

  useEffect(() => {
    let c_data = {total_score : 0, eval_score : 0, level : 0, total_score_U : 0, eval_score_U : 0, level_U : 0, improve_rate : 0};
    compareList.map(curr => {
      c_data.total_score = compareList.reduce( (acc, curr) => acc + curr.total_score,0 );
      c_data.eval_score = compareList.reduce( (acc, curr) => acc + curr.eval_score,0 );
      c_data.total_score_U = compareList.reduce( (acc, curr) => acc + curr.total_score_U,0 );
      c_data.eval_score_U = compareList.reduce( (acc, curr) => acc + curr.eval_score_U,0 );
      return c_data;
    });
    c_data.level = (c_data.eval_score /  c_data.total_score) * 100;
    c_data.level_U = (c_data.eval_score_U /  c_data.total_score_U) * 100;
    c_data.improve_rate = c_data.level_U - c_data.level;
    setCompareSumData(c_data);
  }, [compareList]);

    return (
        <>
            <div id="divTabs3" className="section" style={{height:getGridTableHeight(210), overflowY:'auto'}}>
                <div className="sub_title">
                        {'■ 이행진단 전·후 보안수준'}
                        <span style={{color:'blue',paddingLeft:'20px'}}>※ 이행진단의 결과로 등록된 자산은 파란색상으로 표시됩니다.</span>
                </div>
                <div style={{padding: '5px 10px'}}>
                    <Table 
                        columns={compareColumnData}
                        dataSource={compareList}
                        pagination={false}
                        bordered size={"small"}
                        className="sub_table"
                        summary={(compareList) => {
                          const s_total_score = compareList.reduce( (acc, curr) => acc + curr.total_score,0 );
                          const s_eval_score = compareList.reduce( (acc, curr) => acc + curr.eval_score,0 );
                          const s_level = (s_eval_score /  s_total_score) * 100;

                          const s_total_score_U = compareList.reduce( (acc, curr) => acc + curr.total_score_U,0 );
                          const s_eval_score_U = compareList.reduce( (acc, curr) => acc + curr.eval_score_U,0 );
                          const s_level_U = (s_eval_score_U /  s_total_score_U) * 100;

                          // 아래 합산 계산과 다른 값이 나올 수 있으므로 여기서도 반올림 필요
                          const improve_rate = (s_level_U?s_level_U:0).toFixed(1) - (s_level?s_level:0).toFixed(1);
                          return (
                            <>
                              <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={2}>{'평균'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{amountFormatter(s_total_score,0)}{'(합)'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{amountFormatter(s_eval_score,0)}{'(합)'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{floatFormatter(s_level,1)}%</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>{amountFormatter(s_total_score_U,0)}{'(합)'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={3}>{amountFormatter(s_eval_score_U,0)}{'(합)'}</Table.Summary.Cell>
                                <Table.Summary.Cell index={4}>{floatFormatter(s_level_U,1)}%</Table.Summary.Cell>
                                <Table.Summary.Cell index={10}>{improve_rate > 0 ? (
                                                <span style={{color:'blue'}}> {floatFormatter(improve_rate,1)}%</span>
                                           ) : (<span style={{color:'black'}}> {floatFormatter(improve_rate,1)}%</span>)}
                                </Table.Summary.Cell>
                              </Table.Summary.Row>
                            </>
                          );
                      }}
                      >
                  </Table>
                </div>
                <div style={{padding: '5px 10px', height: '300px'}}>
                    <Chart04 compareSumData={compareSumData} />
                </div>
            </div>
        </>
    );
}
export default Summary;